import { render, staticRenderFns } from "./ProfilDaerahMain.vue?vue&type=template&id=26068e81&scoped=true"
import script from "./ProfilDaerahMain.vue?vue&type=script&lang=js"
export * from "./ProfilDaerahMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26068e81",
  null
  
)

export default component.exports